export default "__VITE_ASSET__BhmPw6Yt__"